import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import get from 'lodash/get';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { REDUCER_NAME, editCsvFormat } from 'src/reducers/clients/csvFormats';
import { CLIENT_SETTINGS, CLIENT_CSV_FORMATS_LIST } from 'src/constants/EndpointUrls';
import { CLIENT_CSV_FORMAT_FORM } from 'src/constants/FormNames';
import { fetchCsvAvailableFields, fetchAllGroupsAndSubgroups } from 'src/reducers/fetchSelectOptions';
import { getItem, setItem } from 'src/reducers/common/itemReducer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import ClientCsvFormatForm from './components/ClientCsvFormatForm';
import { withTranslation } from 'react-i18next';

const RdxClientCsvFormatForm = reduxForm({
  form: CLIENT_CSV_FORMAT_FORM
})(ClientCsvFormatForm);

const ConnectedClientCsvFormatForm = connect(
  (state, { goBackPath }) => {
    const clientCsvFormats = get(state.clientCsvFormats, 'item.data') || {};

    return {
      initialValues: {
        clientCsvFormat: clientCsvFormats.clientCsvFormat,
        clientCsvFormatFields: clientCsvFormats.currentSelectedFields,
        clientCsvFormatGroups: clientCsvFormats.currentSelectedGroups,
        goBackPath
      },
      allGroups: getSelectOptions(state, 'groups'),
      csvAvaiableItems: getSelectOptions(state, 'csvAvaiableItems'),
      clientCsvData: getItem(REDUCER_NAME, state)
    };
  },
  dispatch => ({
    onSubmit: data => dispatch(editCsvFormat(data))
  })
)(RdxClientCsvFormatForm);

class ClientCsvFormatEdit extends React.Component {
  componentWillMount() {
    const { dispatch, values } = this.props;

    dispatch(setItem(REDUCER_NAME, values));
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchCsvAvailableFields());
    dispatch(fetchAllGroupsAndSubgroups());
  }

  render() {
    const search = this.props.location.search;
    const params = new window.URLSearchParams(search);
    const goBackPath = params.get('back');

    return (
      <div className="l-wrap-xl l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={this.props.t('features.ClientCsvFormats.ClientCsvFormatList.CSV_format_list')} path={CLIENT_CSV_FORMATS_LIST} />
            <BreadCrumb.Item label={this.props.t('features.ClientCsvFormats.ClientCsvFormatEdit.edit_CSV_format')} path={CLIENT_CSV_FORMATS_LIST} />
          </BreadCrumb>
        </div>
        <ConnectedClientCsvFormatForm isCreateForm={false} goBackPath={goBackPath} />
      </div>
    );
  }
}

export default withTranslation('translation')(connect()(ClientCsvFormatEdit));
